export default { RELEASE: process.env.RELEASE || 'dev' }
